import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthProvider';
import useToken from '../../hooks/useToken';

const Signup = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { createUser, updateUser } = useContext(AuthContext);
  const [signUpError, setSignUPError] = useState('');
  const [createdUserEmail, setCreatedUserEmail] = useState('');
  const [token] = useToken(createdUserEmail);
  const navigate = useNavigate();

  if(token){
    navigate('/');
  }

  const handleSignUp = (data) => {
      setSignUPError('');
      createUser(data.email, data.password)
          .then(result => {
              const user = result.user;
              console.log(user);
              toast('User Created Successfully.')
              const userInfo = {
                  displayName: data.name
              }
              updateUser(userInfo)
                  .then(() => {
                    saveUser(data.name, data.email);
                   })
                  .catch(err => console.log(err));
          })
          .catch(error => {
              console.log(error)
              setSignUPError(error.message)
          });
  }

  const saveUser = (name, email)=>{
    const user={name, email};
    fetch('https://doctors-portal-server-bayaziddeveloper-gmailcom.vercel.app/users',{
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(user)
    })
    .then(res => res.json())
    .then(data =>{
      setCreatedUserEmail(email);

    })
  };



    return (
        <div className="h-[800px] flex justify-center items-center">
      <div className="w-96 p-7">
      <h2 className="text-xl text-center">Sign Up</h2>
      <form onSubmit={handleSubmit(handleSignUp)}>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text">Name</span>
          </label>
          <input type="text" {...register("name", {required: "Name is required"})}
            className="input input-bordered w-full max-w-xs"/>
            {errors.name && <p className="text-red-600">{errors.name?.message}</p>}
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text">Email Address</span>
          </label>
          <input type="text" {...register("email", {required: "Email Address is required"})}
            className="input input-bordered w-full max-w-xs"/>
            {errors.email && <p className="text-red-600">{errors.email?.message}</p>}
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text">Password</span>
          </label>
          <input
            type="password"
            {...register("password", {
              required: "Password is required",
              minLength: {value: 6, message: 'Password must have uppercase & special character'},
              pattern: {value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/, message: 'Password must be strong'} 
            })}
            className="input input-bordered w-full max-w-xs"
          />
          {errors.password && <p className="text-red-600">{errors.password?.message}</p>}
        </div>
        <input className="btn btn-accent w-full mt-4" value='sign up' type="submit" />
         {signUpError && <p className='text-red-600'>{signUpError}</p>}
      </form>
      <p className="mt-3">Already have an account? <Link className="text-secondary" to='/login'>Log in</Link> </p>
      <div className="divider">OR</div>
      <button className="btn btn-outline w-full">CONTINUE WITH GOOGLE</button>
      </div>
    </div>
    );
};

export default Signup;